module.exports = __webpack_public_path__ + "static/media/price_check.2d402ddc.svg";